@if (seOfrece()) {
  <button
    #disparador
    type="button"
    class="sg-org__disparador"
    aria-haspopup="menu"
    [attr.aria-expanded]="abierto()"
    [attr.aria-label]="'org.switcher.open' | translate: { tenant: tenant() ?? '' }"
    (click)="alternar($event)">
    @if (variante === 'ajustes') {
      <span>{{ 'org.switcher.change' | translate }}</span>
    } @else {
      <span class="sg-org__actual">{{ tenant() }}</span>
    }
    <svg class="sg-org__chevron" viewBox="0 0 12 8" aria-hidden="true">
      <path d="M1 1.5l5 5 5-5" fill="none" stroke="currentColor" stroke-width="1.5" />
    </svg>
  </button>

  @if (abierto()) {
    <div
      class="sg-org__menu"
      role="menu"
      [attr.aria-label]="'org.switcher.title' | translate"
      (keydown)="teclado($event)">
      <div class="sg-org__titulo" aria-hidden="true">{{ 'org.switcher.title' | translate }}</div>

      @for (o of org.organizaciones(); track o.id) {
        <button
          type="button"
          role="menuitemradio"
          class="sg-org__opcion"
          [class.sg-org__opcion--actual]="o.current"
          [attr.aria-checked]="o.current"
          [disabled]="o.current || org.cambiandoA() !== null"
          (click)="elegir(o)">
          <span class="sg-org__textos">
            <span class="sg-org__nombre">{{ o.displayName }}</span>
            <span class="sg-org__slug">{{ o.name }}</span>
          </span>
          @if (org.cambiandoA() === o) {
            <i class="pi pi-spin pi-spinner sg-org__marca" aria-hidden="true"></i>
          } @else if (o.current) {
            <i class="pi pi-check sg-org__marca" aria-hidden="true"></i>
          }
        </button>
      }

      @if (org.estado() === 'cargando') {
        <p class="sg-org__aviso">{{ 'org.switcher.loading' | translate }}</p>
      }

      @if (org.estado() === 'error') {
        <p class="sg-org__aviso sg-org__aviso--error">{{ 'org.switcher.loadError' | translate }}</p>
        <button
          type="button"
          role="menuitem"
          class="sg-org__accion"
          [disabled]="org.cambiandoA() !== null"
          (click)="reintentar()">
          <i class="pi pi-refresh" aria-hidden="true"></i>
          <span>{{ 'org.switcher.retry' | translate }}</span>
        </button>
        <button
          type="button"
          role="menuitem"
          class="sg-org__accion"
          [disabled]="org.cambiandoA() !== null"
          (click)="elegirEnAuth0()">
          <i class="pi" [class.pi-external-link]="org.cambiandoA() !== 'auth0'" [class.pi-spin]="org.cambiandoA() === 'auth0'" [class.pi-spinner]="org.cambiandoA() === 'auth0'" aria-hidden="true"></i>
          <span>{{ 'org.switcher.pickInAuth0' | translate }}</span>
        </button>
      }

      <p class="sg-org__nota">{{ 'org.switcher.note' | translate }}</p>
    </div>
  }
} @else if (variante === 'barra' && tenant()) {
  <span class="sg-org__solo">{{ tenant() }}</span>
}
